module.exports = __webpack_public_path__ + "static/media/close.fc4d4651.svg";